import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { AiOutlineMenu, } from 'react-icons/ai'
import { RxCross1 } from 'react-icons/rx'
import logo from '../assets/logo.jpeg'
import MenuLinks from './MenuLinks'

const NavBar = () => {
  const [toggleMenu, setToggleMenu] = useState(false)
  
  const isActiveStyle = 'border-b-2 mx-3 border-white font-extrabold transaction-all duration-200 ease-in-out hover:shadow-xl py-1'
  const isNotActiveStyle = 'pl-3 hover:font-extrabold transaction-all duration-200 ease-in-out capitalize hover:shadow-xl py-1'
  

  return (
    <nav className='md:p-5 p-4 bg-primary text-white w-full relative '>
      <div className='md:hidden flex flex-row justify-between items-center px-[10px]'>
        <Link to='/'>
          <img src={logo} alt="LOGO" className='w-[60px] rounded-lg'/>
        </Link>

        <Link to='/' className='text-gradient text-lg font-bold' >Mlimi-Wamakono</Link>

        <button onClick={() => {setToggleMenu(!toggleMenu)}}>

          {
            !toggleMenu ? <AiOutlineMenu fontSize={28}/> : <RxCross1 fontSize={28} />
          }

          {
            toggleMenu && (
              <div className='absolute top-[92px] right-0 bg-primary p-10 rounded-b-xl z-[10]'>
                <MenuLinks styles={'flex flex-col gap-y-5 text-gradient'} />
                <hr className='my-8'/>
                <NavLink 
                  to='/register'
                  className={({isActive}) => isActive ? isActiveStyle : isNotActiveStyle}
                  key='register'
                >
                  Register
                </NavLink>
              </div>
            )
          }
          
        </button>
      </div>
      <div className='md:flex hidden flex-row items-center justify-between px-[5px]'>
        <Link to='/'>
          <img src={logo} alt="LOGO" className='w-[58px]'/>
        </Link>

        <div>
          <MenuLinks styles={'flex flex-row flex-1 text-gradient'} />
        </div>
        

        <div>
          <NavLink 
            to='/register'
            className={({isActive}) => isActive ? isActiveStyle : isNotActiveStyle}
            key='register'
          >
            Register
          </NavLink>
        </div>
      </div>
    </nav>
  )
}

export default NavBar
